export const THINKING_LEVELS = ["none", "low", "medium", "high", "xhigh"];
const keyFor = (scope, sessionId) => `growthos.chat.thinking.v1:${JSON.stringify([scope, sessionId])}`;

export function thinkingState(value) {
  const status = ["enabled", "off", "unavailable"].includes(value?.status) ? value.status : "unavailable";
  return {
    status,
    defaultEffort: THINKING_LEVELS.includes(value?.defaultEffort) ? value.defaultEffort : "medium",
    options: THINKING_LEVELS,
  };
}

// A session preference, not an account setting. No prompts or transcripts go into storage.
export function readThinking(scope, sessionId) {
  try {
    const saved = window.localStorage.getItem(keyFor(scope, sessionId));
    return THINKING_LEVELS.includes(saved) ? saved : null;
  } catch { return null; }
}

export function saveThinking(scope, sessionId, value) {
  try {
    if (value === null) window.localStorage.removeItem(keyFor(scope, sessionId));
    else window.localStorage.setItem(keyFor(scope, sessionId), value);
    return true;
  } catch { return false; }
}
